import type { CalendarSyncStatus } from '@recruitee/dashboard-types';
import { createSingleEntityStore } from '@recruitee/ngrx';

export const {
  actions: CalendarSyncStatusActions,
  reducer: CalendarSyncStatusReducer,
  selectors: CalendarSyncStatusSelectors,
  namespace: CalendarSyncStatusNamespace,
} = createSingleEntityStore<CalendarSyncStatus>()('CalendarSyncStatus');
